exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.6@core-js/library/modules/_object-pie.js
// module id = 94
// module chunks = 0 1